<template>
  <popup
    :close-action="closeActionClicked"
    :title="'פרטי בעל הכרטיס'"
    :buttons="buttons">
    <template v-slot:content>
      <text-input
        :autofocus="true"
        :labelText="'שם פרטי'"
        :value="firstName"
        :onInput="setFirstName"/>

      <text-input
        :autofocus="false"
        :labelText="'שם משפחה'"
        :value="lastName"
        :onInput="setLastName"/>

      <text-input
        :autofocus="false"
        :labelText="'מס׳ נייד'"
        :value="phoneNumber"
        :onInput="setPhoneNumber"
        :inputPattern="'\\d*'"/>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import { mapActions, mapGetters, mapState } from 'vuex';
import Segment from '../../../../../Segment';

export default {
  name: 'EditPersonalInputPopup',
  components: {
    TextInput: BaseUI.TextInput,
    Popup: BaseUI.Popup,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      phoneNumber: '',
    };
  },
  async created() {
    Segment.trackUserInteraction('EditPersonalInfoPopupShown');
    this.firstName = this.personalInfo[this.personalInfoFields.firstName].value;
    this.lastName = this.personalInfo[this.personalInfoFields.lastName].value;
    this.phoneNumber = this.personalInfo[this.personalInfoFields.phoneNumber].value;
  },
  computed: {
    ...mapState('subscription', ['personalInfo']),
    ...mapGetters('subscription', ['personalInfoFields']),
    disabled() {
      return _.trim(this.firstName).length < 2
        || _.trim(this.lastName).length < 2
        || _.trim(this.phoneNumber).length < 10;
    },
    buttons() {
      return [
        {
          title: 'שמירה',
          disabled: this.disabled,
          action: this.saveUpdatedInfo,
          size: 'small',
        },
      ];
    },
  },
  methods: {
    ...mapActions('subscription', ['setPersonalInfo']),
    saveUpdatedInfo() {
      this.setPersonalInfo({ firstName: this.firstName, lastName: this.lastName, phoneNumber: this.phoneNumber });
      this.closeActionClicked();
    },
    setFirstName(value) {
      this.firstName = value;
    },
    setLastName(value) {
      this.lastName = value;
    },
    setPhoneNumber(value) {
      this.phoneNumber = value;
    },
    closeActionClicked() {
      Segment.trackUserInteraction('EditPersonalInfoPopupClosed');
      this.$emit('close');
    },
  },
};

</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";

  .button-container {
    width: 100%;

    .riseup-button {
      width: 100%;
    }
  }

</style>
